export const makeSvgDataSrc = ({
  width = 15,
  height = 10,
  color = "#D9D9D9",
  text,
  textColor = "#000",
}: {
  width?: number;
  height?: number;
  color?: string;
  text?: string;
  textColor?: string;
} = {}) =>
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="${width}" height="${height}" fill="${color}"/>${
      text
        ? `<text x="${width / 2}" y="${
            height / 2
          }" text-anchor="middle" fill="${textColor}">${text}</text>`
        : ""
    }</svg>`,
  );
